import * as zod from 'zod';

import { DHState } from '@sb/integrations/implementations/dh/comon/types/DHState';

export const DHCGI100170State = DHState.extend({
  kind: zod.literal('DHCGI100170'),
});

export type DHCGI100170State = zod.infer<typeof DHCGI100170State>;
